import React from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"
import { SelectOption } from "shared/types/Select"
import { ProjectImportError } from "shared/types/__generated__/graphql"

import {
  ProjectFormData,
  ProjectFormState
} from "features/project-management/types/ProjectFormData"

import { NewProjectOverlayView } from "./NewProjectOverlayView"
import { useNewProjectOverlayViewModel } from "./model/useNewProjectOverlayViewModel"

export interface NewProjectOverlayModel {
  defaultFormData?: ProjectFormState
  projectPhaseOptions: SelectOption<string>[]
  isLoadingProjectPhaseOptions?: boolean
  isXlsxUploadDisabled?: boolean
  isSubmitting?: boolean
  onCancel: () => void
  onSubmit: (
    project: ProjectFormData
  ) => Promise<{ errors?: ProjectImportError[] } | void>
  onXlsxUpload?: (file: FilePreview) => Promise<ApiResponse<unknown>>
  onXlsxDelete?: () => void
  xlsxExampleUrl?: string
}

export interface NewProjectOverlayProps extends NewProjectOverlayModel {
  autoFocus?: boolean
}

export const NewProjectOverlay = React.memo((props: NewProjectOverlayProps) => (
  <NewProjectOverlayView {...useNewProjectOverlayViewModel(props)} />
))
